import React from 'react'
import {ItemIconClass} from "../../../gd/const/item-icon/icon/item-icon-class";

type Props = {
    className?      : string

    size?           : 'normal' | 13 | '14' | 14 | '15' | 15 | '24' | 24 | 48
    event           : any

    hint?           : boolean
    accomplished?   : boolean
    showPastDue?    : boolean
    summaryMode?    : boolean // used at least in events summary render checkmark instead of icon where needed
}

export default class EventIcon extends React.Component<Props> {

    static defaultProps = {
        size        : 'normal',
        hint        : false,
        showPastDue : true,
        summaryMode : false
    }

    getIconClass = () => {
        let result  = ""
        const start = this.props.event.startDate ? moment(this.props.event.startDate) : null
        const end   = this.props.event.endDate ? moment(this.props.event.startDate) : start

        switch (this.props.event.type) {
            case gd.const.event.type.PROJECT_EVENT              :
                if (this.props.summaryMode && end?.isBefore(moment(),'days'))                           result = "i5-checkbox-ok"
                else if (start && start.isBefore(moment(),'days'))                                      result = "i5-event-project-event past"
                else                                                                                    result = "i5-event-project-event"
                break;
            case gd.const.event.type.PROJECT_MILESTONE          :
                if (this.props.summaryMode && this.props.event.isAccomplished)                          result = "i5-checkbox-ok"
                else if (this.props.event.isAccomplished)                                               result = "i5-milestone done"
                else if (this.props.showPastDue && start && start.isBefore(moment(),'days'))            result = "i5-milestone pastdue-state"
                else                                                                                    result = "i5-milestone"
                break;
            case gd.const.event.type.PROJECT_DEADLINE           :
                if (this.props.summaryMode && this.props.event.isAccomplished)                          result = "i5-checkbox-ok"
                else if (this.props.event.isAccomplished)                                               result = "i5-event-project-deadline done"
                else if (this.props.showPastDue && start && start.isBefore(moment(),'days'))            result = "i5-event-project-deadline pastdue-state"
                else                                                                                    result = "i5-event-project-deadline"
                break;
            case gd.const.event.type.PROJECT_CREATED            :                                       result = "i5-event-project-created"; break

            case gd.const.event.type.COMPANY_EVENT              :
                if (this.props.summaryMode && end?.isBefore(moment(),'days'))                           result = "i5-checkbox-ok"
                else                                                                                    result = "i5-organization"
                break;
            case gd.const.event.type.COMPANY_HOLIDAY            :                                       result = "i5-event-company-holiday"; break

            case gd.const.event.type.PERSONAL_PAID_VACATION     :                                       result = "i5-event-personal-vacation"; break
            case gd.const.event.type.PERSONAL_NON_PAID_VACATION :                                       result = "i5-event-personal-vacation"; break
            case gd.const.event.type.PERSONAL_SICK_LEAVE        :                                       result = "i5-event-personal-sick-leave"; break
            case gd.const.event.type.PERSONAL_TRAVEL            :                                       result = "i5-event-personal-travel"; break

            case gd.const.event.type.TASK_DEADLINE:
            case gd.const.event.type.TASK_SCHEDULE:
            case gd.const.event.type.TASK_START_END:
                const taskType = gd.session.taskTypes.get(this.props.event.task.taskTypeId);
                const icon = taskType ? ItemIconClass[taskType.icon] : ''

                if (this.props.event.isAccomplished)                                                    result = icon + " done"
                else if (this.props.showPastDue && start && start.isBefore(moment(),'days'))            result = icon + " pastdue-state"
                else                                                                                    result = icon
                break
        }

        return result
    }

    render() {
        const classes = Classes("gd-event-ico", this.getIconClass(), this.props.className, {
            'hint--top' : this.props.hint,
            'size14'    : this.props.size === "14",
            'size15'    : this.props.size === "15" || this.props.size === 15,
            'size24'    : this.props.size === "24" || this.props.size === 24,
            'size48'    : this.props.size === 48
        })

        let specialIcon
        if (this.props.accomplished) {
            specialIcon = <div className="status-icon i5-checkbox-ok"/>
        }

        if (this.props.hint) {
            console.error("event icon hint ne sdelan !")
            return <div className={classes} data-hint={gd.const.event.typeList[this.props.event.type]}>{specialIcon}</div>
        } else {
            return <div className={classes}>{specialIcon}</div>
        }
    }
}